export const fieldTranslations: Record<string, string> = {
  date: "Date",
  description: "Description",
  quantity: "Quantité",
  market_value_local_ccy: "Valeur marché (devise locale)",
  market_value_ptf_ccy: "Valeur marché (devise ptf)",
  fees: "Frais",
  tax: "Taxe",
  custodian_broker_fee: "Frais dépositaire",
  broker_fee: "Frais courtier",
  other_fee: "Autres frais",
  fee_currency: "Devise des frais",
  fee_type: "Type de frais",
  category: "Type de mouvement",
  transfer: "Type de transfert",
  c3_portfolio_id: "Portefeuille (id)",
  c3_static_datum_id: "Actif (id)",
  time_serie_file_id: "Fichier (id)",
  c3_time_serie_file_id: "Fichier c3 (id)",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
